

import React, { memo } from 'react';
import { Text, Button } from '../../../../../ui-kit';







const AddonsFinalSelection = (
{
  totalAddon,
  onClose,
  onApplyChanges
}) =>
<div className="custom-addons__final-cost">
      <Text heading5 noMargin>
        {totalAddon}
        {' '}
        Add-ons selected
      </Text>
      <div className="custom-addons__final-cost__button">
        <Button type="TERTIARY" onClick={onClose}>Back</Button>
        <Button
      type="PRIMARY"
      onClick={() => onApplyChanges()}>

          Apply Changes
        </Button>
      </div>
    </div>;


export default memo(AddonsFinalSelection);